import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { getContentObjectDetailQueryKey, getFeedKey } from 'features/feed/queries/keys';
import type { Log } from 'models/service';
import { createTaskLog } from '../../services';

type P = {
  activityId: string;
  body: Log[];
};

export const useCreateTaskLogMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, P>({
    async mutationFn({ activityId, body }) {
      return createTaskLog({ body, routeParams: { id: activityId } });
    },
    onSuccess(_data, { activityId }) {
      void queryClient.invalidateQueries({ queryKey: getContentObjectDetailQueryKey({ id: activityId }) });
      void queryClient.invalidateQueries({ queryKey: getFeedKey() });
    },
  });
};
